export const isRecord = (arg: unknown): arg is Record<string, unknown> =>
    typeof arg === 'object' && arg !== null && !(arg instanceof Array);
